/**
 * Browser-safe usage of process
 */
var defaultEnvironment = "production";
var env = typeof process === "undefined" || process.env === undefined
    ? defaultEnvironment
    : process.env.NODE_ENV || defaultEnvironment;

export { env };



//////////////////
// WEBPACK FOOTER
// ./node_modules/framer-motion/dist/es/utils/process.mjs
// module id = hf4q
// module chunks = 0